<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-form ref="form" :inline="true" :model="searcheModel">
                <el-form-item label="用户ID">
                    <el-input size="small" v-model="searcheModel.user_id" placeholder="请输入用户ID"></el-input>
                </el-form-item>
                <el-form-item label="用户名">
                    <el-input size="small" v-model="searcheModel.username" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="所在学校" class="customer-input" >
                    <CustomerSelect ref="CustomerSelect" :customerIdss="searcheModel.customer_name" v-model="searcheModel.customer_name" @change="CustomerHandleChange"></CustomerSelect>
                </el-form-item>
                <el-form-item label="产品类型">
                    <Product ref="product" :product_id="searcheModel.product_id"
                    @change="productChange"></Product>
                </el-form-item>
                <!-- <el-form-item label="状态">
                    <el-select size="small" v-model="searcheModel.status" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="关闭" value="0"></el-option>
                        <el-option label="开启" value="1"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="风险IP">
                    <el-select size="small" v-model="searcheModel.risk_ip" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="风险IP访问" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="风险账号">
                    <el-select size="small" v-model="searcheModel.risk_uid" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="风险账号访问" value="1"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                </el-form-item>
            </el-form>

            <div>
                <p style="color:#85CE61;">
                    统计数据同步时间：7:00<br>
                    <!-- 数据不能超过50000条 -->
                </p>
            </div>

            <el-table
                v-if="!loading"
                :data="list" 
                height="600"
                border 
                :header-cell-style="{background: '#f3faff'}"
                @sort-change="submitSearch($event)"
            >
                <el-table-column prop="user_id" label="用户ID"></el-table-column>
                <el-table-column prop="username" label="用户名"></el-table-column>
                <el-table-column prop="customer_name" label="所在学校">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">
                            {{ scope.row.customer_name }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="启用产品">
                    <template slot-scope="scope">
                        <span v-for="(item, index) in products" v-show="!scope.row.close_product_ids.includes(item.id)" :key="index">
                            {{item.name}}&nbsp;&nbsp;&nbsp;
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="item_down_num" label="资源下载数"></el-table-column>
                <el-table-column prop="paper_down_num" label="组卷下载数"></el-table-column>
                <!-- <el-table-column prop="" label="状态"></el-table-column> -->
                <el-table-column prop="risk_ip" label="风险IP">
                    <template slot-scope="scope">
                        <span style="color:red;">
                            {{ scope.row.risk_ip }}
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="risk_uid" label="风险账号">
                    <template slot-scope="scope">
                        <span style="color:red;">
                            {{ scope.row.risk_uid }}
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="dialogView(scope.row)">详情</el-button>
                        <el-button type="text" size="small" @click="dialogShow(scope.row)">下载日志</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>
        <DownLogDialog v-if="dialogTableVisible" :params="params" @close="closeDialog"></DownLogDialog>
        <ViewDialog v-if="dialogViewVisible" :params="params" @close="closeDialog"></ViewDialog>
    </div>
</template>dialogViewVisible
<script>
import GuanbiCount from "~/services/GuanbiCount";
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import Product from "~/widgets/Product.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import Config from "~/config/params";
import DownLogDialog from "~/views/public_acc/downLogDialog.vue";
import ViewDialog from "~/views/public_acc/viewDialog.vue";
export default{
    components: {
        CustomerSelect,
        Product,
        MyPagination,
        Config,
        DownLogDialog,
        ViewDialog
    },

    data() {
        return {
            loading: false,
            searcheModel: {},
            list: [],
            linkPage: null,
            activeName: 'public-account-list',
            dialogTableVisible: false,
            dialogViewVisible: false,
            params: {},
            count_data: {},
            products: [
                {name: '二一校网通', id: 2},
                // {name: '二一组卷', id: 1},
                {name: '校本资源库', id: 5},
            ],
        };
    },

    created(){
        this.resetForm();
    },
    
    methods: {

        //重置按钮
        resetForm() {
            this.searcheModel = {
                username: '',
                user_id: '',
                customer_name: '',
                product_id: '',
                status: '',
                risk_ip: '',
                risk_uid: ''
            };
            if(this.$refs['CustomerSelect']){
                this.$refs['CustomerSelect'].reset();
            }
            if(this.$refs['product']){
                this.$refs['product'].reset();
            }
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch($data = null) {
            if($data && typeof $data.order !== undefined){
                this.searcheModel.sort_name = $data['prop'];
                this.searcheModel.sort_by = $data['order'];
            }
            let params = _.clone(this.searcheModel);
            params['page'] = 1;
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            this.list = [];
            GuanbiCount.getCount(params, this.activeName)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (this.list.length > 0 && res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //客户名称远程搜索组件赋值
        CustomerHandleChange(object) {
            this.searcheModel.customer_name = object.value;
        },

        productChange(value) {
            this.searcheModel.product_ids = [value];
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            let params = this.searcheModel;
            params['perPage'] = newSize;
            this.getList(params);
        },

        handleCurrentChange(newPage) {
            let params = this.searcheModel;
            // 处理当前页码变化事件
            params['page'] = newPage;
            this.getList(params);
        },

        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/customers/view",
                query: { id: row.customer_id },
            });
            window.open(routeData.href, '_blank');
        },

        dialogView(item){
            this.params = {
                user_id: item.user_id,
                customer_id: item.customer_id,
            };
            this.dialogViewVisible = true;
        },

        dialogShow(item){
            this.params = {
                uid: item.user_id,
                user: item.user_id,
            };
            this.dialogTableVisible = true;
        },

        closeDialog(){
            this.dialogViewVisible = false;
            this.dialogTableVisible = false;
            this.params = {};
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/public_acc/list.vue